import React from 'react'
import { Dialog, useTheme, useMediaQuery } from '@mui/material'
import { LeadStatusesResponse } from '../../../hooks/leads/useLeadStatuses'
import { StatusDialogHeader } from './StatusDialogHeader'
import { CreateStatusForm } from './CreateStatusForm'
import { EditStatusList } from './EditStatusList'
import { useAddCustomLabel } from './useAddCustomLabel'

interface AddCustomLabelDialogProps {
  open: boolean
  onClose: () => void
  onComplete: (res?: LeadStatusesResponse, createdStatus?: string) => void
  smbId: string
  customStatuses: string[]
}

const AddCustomLabelDialog: React.FC<AddCustomLabelDialogProps> = ({
  open,
  onClose,
  onComplete,
  smbId,
  customStatuses,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const {
    newLabelInput,
    setNewLabelInput,
    editingStatus,
    setEditingStatus,
    renameInput,
    setRenameInput,
    isLoading,
    error,
    setError,
    activeTab,
    setActiveTab,
    displayList,
    handleClose,
    handleCreateSubmit,
    handleRenameInitiate,
  } = useAddCustomLabel({ open, smbId, customStatuses, onClose, onComplete })

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          m: isMobile ? 1 : undefined,
          width: isMobile ? 'calc(100% - 16px)' : undefined,
          height: 'min(380px, 85vh)',
          borderRadius: '12px',
          boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.08)',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <StatusDialogHeader
        activeTab={activeTab}
        onTabChange={(val) => {
          setActiveTab(val)
          setError(null)
          setEditingStatus(null)
          setRenameInput('')
        }}
        onClose={handleClose}
        isLoading={isLoading}
      />

      {activeTab === 0 ? (
        <CreateStatusForm
          statusInput={newLabelInput}
          onStatusInputChange={(val) => {
            setNewLabelInput(val)
            if (error) setError(null)
          }}
          onSubmit={handleCreateSubmit}
          onClose={handleClose}
          isLoading={isLoading}
          error={error}
          smbId={smbId}
        />
      ) : (
        <EditStatusList
          displayList={displayList}
          editingStatus={editingStatus}
          renameInput={renameInput}
          onRenameInputChange={(val) => {
            setRenameInput(val)
            if (error) setError(null)
          }}
          onInitiateRename={handleRenameInitiate}
          onCancelRename={() => setEditingStatus(null)}
          onStartEdit={(statusName) => {
            setEditingStatus(statusName)
            setRenameInput(statusName)
          }}
          onClose={handleClose}
          isLoading={isLoading}
          error={error}
        />
      )}
    </Dialog>
  )
}

export default AddCustomLabelDialog
